<template>
    <div>
        <bv-top></bv-top>
        <card-detail>
            <div>
                <table>
                    <tr style="font-size: 16px">
                        <th width="25%">类别</th>
                        <th width="25%">金额</th>
                        <th width="25%">日期</th>
                        <th width="25%">账户余额</th>
                    </tr>
                    <tr :key="houseTrade.busiNo" v-for="houseTrade in houseTradeList" class="content-left">
                        <td>{{houseTrade.tradeTypeName}}</td>
                        <td v-if="houseTrade.ioFlag == 'I'">+{{houseTrade.amountFormat}}</td>
                        <td v-if="houseTrade.ioFlag == 'O'">-{{houseTrade.amountFormat}}</td>
                        <td>{{houseTrade.tallyDate}}</td>
                        <td style="float: right">{{houseTrade.balanceFormat}}</td>
                    </tr>
                </table>
            </div>
        </card-detail>
    </div>
</template>

<script>
    import CardDetail from '@/components/card-detail.vue'
    import Top from '@/views/components/Top'
    export default {
        name: "HouseTradeList",
        data(){
          return{
              houseInfo:{},
              houseTradeList: this.$route.query.param,
              arcShareOwnerInfoList:[]

          }
        },
        components:{
            BvTop:Top,
            CardDetail
        },
        methods:{}
    }
</script>

<style lang="scss">
    .content-left{
        color: #999;
    }
</style>
